import { FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { LinkList } from '../types'
import { Text } from '../../../atoms/text'
import { Button } from '../../../atoms/button'
import { Link } from 'gatsby'

const DesktopLinkLists: FunctionComponent<{ linkLists: LinkList[] }> = ({ linkLists }) => {
  return (
    <GridContainer>
      {linkLists.map(linkList => {
        const titleId = `footer-nav-${linkList.title.toLowerCase().replace(/\s+/g, '-')}`
        return (
          <ListItem key={linkList.title}>
            <nav aria-labelledby={titleId}>
              <LinkListTitle as="h2" fontStyle="label-l" id={titleId}>
                {linkList.title}
              </LinkListTitle>
              <LinkItemsList>
                {linkList.links.map((link, index) => (
                  <li key={`${link.title}-${index}`}>
                    <LinkListItem
                      variant="ghost"
                      themeOverride="background_is_lighter"
                      as={link.openInNewTab ? 'a' : Link}
                      {...(link.openInNewTab ? { href: `${link.link}` } : { to: `${link.link}` })}
                      target={link.openInNewTab ? '_blank' : '_self'}
                      rel={link.openInNewTab ? 'noopener noreferrer' : undefined}
                    >
                      <Text fontStyle="label-m" as="span">
                        {link.title}
                      </Text>
                    </LinkListItem>
                  </li>
                ))}
              </LinkItemsList>
            </nav>
          </ListItem>
        )
      })}
    </GridContainer>
  )
}

const GridContainer = styled.div`
  grid-area: linkList;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  grid-template-areas:
    'list1 list2 list4'
    'list1 list3 list4';
  gap: 3rem 2rem;

  list-style: none;
`

const LinkListTitle = styled(Text)`
  text-transform: uppercase;
  color: var(--beige-300);
  margin-bottom: var(--spacing-xl);
  white-space: nowrap;
`
const ListItem = styled.div`
  max-width: 12rem;
  &:first-of-type {
    grid-area: list1;
  }

  &:nth-of-type(2) {
    grid-area: list2;
  }

  &:nth-of-type(3) {
    grid-area: list3;
  }

  &:nth-of-type(4) {
    grid-area: list4;
  }
`

const LinkItemsList = styled.ul`
  list-style: none;
  display: grid;
  gap: 1.25rem;
  color: var(--beige-250);
`

const LinkListItem = styled(Button)`
  width: fit-content;
  padding: 0;
  text-align: left;
  text-transform: none;
  color: var(--beige-250);
  &:hover {
    color: var(--beige-200);
  }
`

export default DesktopLinkLists
